import { render, staticRenderFns } from "./DeviceTypeConfig.vue?vue&type=template&id=23d28a1c&scoped=true"
import script from "./DeviceTypeConfig.vue?vue&type=script&lang=js"
export * from "./DeviceTypeConfig.vue?vue&type=script&lang=js"
import style0 from "./DeviceTypeConfig.vue?vue&type=style&index=0&id=23d28a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d28a1c",
  null
  
)

export default component.exports